import { useLogout } from '../hooks/use-logout';
import { DangerButton } from './buttons';

const LogoutButton = () => {
  const logout = useLogout();

  return <DangerButton onClick={logout}>Log Out</DangerButton>;
};

export default LogoutButton;
